<template>
  <v-card class="modalidades" v-if="displayModalidades">
    <button
      type="button"
      class="box-close-button"
      aria-label="Close"
      @click="closeToolTip()"
    >
      <span aria-hidden="true">×</span>
    </button>

    <v-card-text>
      <v-layout row wrap v-if="tipoModalidade == 'G'">
        <h3>
          O limite global do tomador é o valor máximo que o tomador pode
          acumular em importâncias seguradas junto a JNS, somando-se todas as
          suas apólices de todas as modalidades.
        </h3>
      </v-layout>
      <div v-if="tipoModalidade == 'F'">
        <h3>As modalidades financeiras são:</h3>
        <v-layout
          v-for="(modalidade, index) in modalidades.FINANCEIRAS"
          :key="index"
          row
          wrap
        >
          <span class="modalidades">{{ modalidade }}</span>
        </v-layout>
      </div>
      <div v-if="tipoModalidade == 'T'">
        <h3>As modalidades tradicionais são:</h3>
        <v-layout
          v-for="(modalidade, index) in modalidades.TRADICIONAIS"
          :key="index"
          row
          wrap
        >
          <span class="modalidades">{{ modalidade }}</span>
        </v-layout>
      </div>
    </v-card-text>
  </v-card>
</template>

<script lang="js">
export default {
  name: "TaxasLimitesToolTip",
  
  props: ["displayModalidades", "tipoModalidade", "modalidades"],
  methods: {
    closeToolTip() {
      this.$emit("close");
    },
  },
};
</script>

<style lang='scss' scoped>
#jns {
  .v-card {
    position: absolute;
    left: 40%;
    width: 500px;
    top: 50%;
  }
  .modalidades {
    padding-left: 10px;
    font-size: 8pt;
    line-height: 0.5ch;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .box-close-button {
    position: absolute;
    cursor: pointer;
    top: 5px;
    right: 5px;
    color: red;
    font-size: 17px;
  }
  h3 {
    line-height: 2ch;
  }
}
</style>


// WEBPACK FOOTER //
// ./src/components/TaxasLimitesToolTip.vue